<template>
    <div v-if="cardItems">
        <div class="row py-lg-4">
            <div
                v-for="(cardItem, index) in cardItems"
                :key="index"
                class="col-12 col-lg-6 col-xl-4 pb-1 pb-lg-3 no-inner-padding"
            >
                <a :href="cardItem.url" class="card">
                    <div class="card__wrapper">
                        <div class="card__background position-relative mb-1">
                            <lazy-background
                                v-if="cardItem.imageObject !== null"
                                :image="cardItem.imageObject"
                            ></lazy-background>
                            <div class="card__content text-right">
                                <span>{{ cardItem.publishDate }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="card__text">
                        <div>
                            <h3 class="uppercase">
                                {{ cardItem.title }}
                            </h3>
                            <p>{{ cardItem.text }}</p>
                        </div>
                        <span>
                            <a :href="cardItem.url">
                                <button
                                    type="submit"
                                    class="btn btn-primary mb-1"
                                >
                                    Lees meer
                                </button></a
                            ></span
                        >
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.card {
    background-color: $color-gray;
    overflow: hidden;
    display: flex;
    height: 100%;
    flex-direction: column;

    &:hover {
        text-decoration: none;
    }
}

.card__wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
}

.card__text {
    padding: 10px 30px 20px 30px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 1 1 auto;
    justify-content: space-between;
}

.card__text p {
    max-height: 75px;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 25px;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    word-break: break-word;
}
</style>

<script>
import LazyBackground from '@/components/lazy-background';

export default {
    components: {
        LazyBackground
    },
    props: {
        cardItems: {
            type: Array,
            default: () => []
        }
    }
};
</script>
